/**
 * SELECT BUTTON TOKENS
 *
 * Custom additions are marked with "Custom" comments below.
 */
import { nbxVar as v } from '../../../tokens/generated/nbx-tokens.js';
import { SEMANTIC, type SemanticTokens } from '../semantic.js';

export function createSelectButtonTokens(s: SemanticTokens) {
  return {
    /** Base spacing for select buttons */
    base: {
      paddingX: v('select-button.base.padding-x'), // --select-button-base-padding-x: var(--spacing-8)
      paddingY: v('select-button.base.padding-y'), // --select-button-base-padding-y: var(--spacing-8)
      gap: v('select-button.base.gap'), // --select-button-base-gap: var(--spacing-8)
      radius: v('select-button.base.radius'), // --select-button-base-radius: var(--radius-8)
      fontWeight: s.typography.fontWeight.bold, // --select-button-base-font-weight
      fontSize: s.typography.fontSize.base, // --select-button-base-font-size
      lineHeight: s.typography.lineHeight.normal, // --select-button-base-line-height
      transition: s.transition.normal, // --select-button-base-transition
    },
    bg: v('select-button.item.bg'), // --select-button-item-bg: var(--surface-raised)
    fg: v('select-button.item.fg'), // --select-button-item-fg: var(--text-tertiary)
    trackOn: v('select-button.item.bg-unselected'), // --select-button-item-track-on: var(--surface-ground)
    trackDisabled: v('select-button.item.bg-disabled'), // --select-button-item-track-disabled: var(--surface-disabled)
    fgActive: v('select-button.item.fg-selected'), // --select-button-item-fg---active: var(--text-secondary)
    fgDisabled: v('select-button.item.fg-disabled'), // --select-button-item-fg-disabled: var(--text-on-color)

    // ──── Custom tokens ────

    bgHover: s.surface.canvas, // --select-button-item-bg-hover: var(--surface-canvas)
  };
}
export const selectButtonTokens = createSelectButtonTokens(SEMANTIC);
